/*
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: 小白
 * @Date: 2022-03-02 13:14:18
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-03-22 13:39:07
 * @FilePath: /chat_gpt/src/api/http.js
 */
import request from './request'
import { HTTP_URI } from './api'
export const REQUEST = {
  POST: function (businessType, datas, isToken) {
    if (!HTTP_URI[businessType]) return
    return request({
      url: HTTP_URI[businessType],
      method: 'post',
      data: datas
    })
  },
  GET: function (businessType, params) {
    return request({
      url: HTTP_URI[businessType],
      method: 'get',
      params: params
    })
  },
  //post请求，地址栏拼接
  POST_LINE: function (businessType, params) {
    if (!HTTP_URI[businessType]) {
      return Promise.reject(new Error(`接口 ${businessType} 未配置`))
    }
    
    // 手动拼接 URL 参数
    const queryString = Object.keys(params || {})
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
    
    const url = queryString 
      ? `${HTTP_URI[businessType]}?${queryString}`
      : HTTP_URI[businessType]
    
    return request({
      url: url,
      method: 'post',
      data: {}  // 必须要有 data，即使为空对象
    })
  }
}
export default REQUEST
